import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadPageComponent } from './upload-page/upload-page.component';
import { DropZoneDirective } from './drop-zone.directive';
import { FileSizePipe } from './file-size.pipe';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SafePipe } from '../games/safe.pipe.directive';
@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule
  ],
  declarations: [UploadPageComponent, DropZoneDirective, FileSizePipe, SafePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [],
  exports: [UploadPageComponent]
})
export class UploadsModule { }
